import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { API } from '../config';
import './Auth.css';

function RecruiterRegister() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    company_name: '',
    user_type: 'RECRUITER'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [sentTo, setSentTo] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.register(formData);
      setSentTo(formData.email);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        setError(detail.map(e => `${e.loc.join(' → ')}: ${e.msg}`).join('\n'));
      } else {
        setError(detail || 'Registration failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  // ── Check-your-email screen ──────────────────────────────────
  if (sentTo) {
    return (
      <div className="auth-container">
        <div className="auth-stars">{[...Array(10)].map((_, i) => <div key={i} className="auth-star" />)}</div>
        <div className="auth-card">
          <div className="auth-header">
            <Link to="/"><img src="/JobLinkedAI.png" alt="JobLinked AI" style={{ height: 80, marginBottom: '1rem' }} /></Link>
            <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>📧</div>
            <h2>Check your email</h2>
            <p>We sent a verification link to</p>
            <p style={{ fontWeight: 700, color: '#1a56db', marginTop: '0.25rem' }}>{sentTo}</p>
          </div>
          <div style={{ padding: '0 1.5rem 1.5rem', textAlign: 'center', color: '#475569', fontSize: '0.9rem', lineHeight: 1.7 }}>
            <p>Click the link in the email to activate your recruiter account. The link expires in 24 hours.</p>
            <p style={{ marginTop: '1rem', fontSize: '0.82rem', color: '#94a3b8' }}>
              Didn't receive it?{' '}
              <button
                style={{ background: 'none', border: 'none', color: '#1a56db', cursor: 'pointer', fontWeight: 600, fontSize: '0.82rem' }}
                onClick={async () => {
                  try {
                    await fetch(`${API}/auth/resend-verification?email=${encodeURIComponent(sentTo)}`, { method: 'POST' });
                    alert('Verification email resent!');
                  } catch { alert('Failed to resend. Try again.'); }
                }}
              >
                Resend email
              </button>
            </p>
          </div>
          <div className="auth-footer">
            <p>Already verified? <Link to="/recruiter/login">Sign in</Link></p>
          </div>
        </div>
      </div>
    );
  }

  // ── Registration form ────────────────────────────────────────
  return (
    <div className="auth-container">
      <div className="auth-stars">{[...Array(10)].map((_, i) => <div key={i} className="auth-star" />)}</div>
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <img src="/JobLinkedAI.png" alt="JobLinked AI" style={{ height: 80, marginBottom: '1rem' }} />
          </Link>
          <h2>Create Recruiter Account</h2>
          <p>Start posting jobs and finding talent</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Full Name</label>
            <input type="text" value={formData.full_name}
              onChange={e => setFormData({ ...formData, full_name: e.target.value })}
              required placeholder="John Doe" />
          </div>
          <div className="input-group">
            <label>Company Name</label>
            <input type="text" value={formData.company_name}
              onChange={e => setFormData({ ...formData, company_name: e.target.value })}
              required placeholder="Acme Corporation" />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input type="email" value={formData.email}
              onChange={e => setFormData({ ...formData, email: e.target.value })}
              required placeholder="recruiter@company.com" />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input type="password" value={formData.password}
              onChange={e => setFormData({ ...formData, password: e.target.value })}
              required placeholder="••••••••" minLength="6" />
          </div>

          {error && (
            <div className="error">
              {error.split('\n').map((line, i) => <div key={i}>{line}</div>)}
            </div>
          )}

          <button type="submit" className="btn btn-full" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already have an account? <Link to="/recruiter/login">Sign in</Link></p>
          <p style={{ marginTop: '0.5rem' }}><Link to="/register">Job seeker? Register here</Link></p>
        </div>
      </div>
    </div>
  );
}

export default RecruiterRegister;
